module.exports = __webpack_public_path__ + "img/image_2.f3dc2492.svg";